











































































import {Component, Vue} from 'vue-property-decorator';
import {addClass} from '@/utils/classUtils';
import {ncpPopup} from '@/utils/ncp';
import {GetOrderProductsRequest, GetShippingsRequest, OriginalAddress} from 'supporter';

@Component({
  components: {}
})
export default class ModifyPopup extends Vue {
  public productInfo: any = [];
  private receiver = {
    orderNo: '',
    name: '',
    zipCd: '',
    address: '',
    detailAddress: '',
    jibunAddress: '',
    contact1: '',
    contact2: '',
    customsIdNumber: '',
    memo: '',
    shippingNo: ''
  }

  private created() {
    this.getOrderProductInfo();
  }

  public getOrderProductInfo(): void {
    let ProductInfoRequest: GetOrderProductsRequest = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getOrderProducts(ProductInfoRequest).then((res): any => {
      this.productInfo = [];
      this.productInfo = [...this.formatterProductInfo(res.data, 'orderOptions')];
      this.formatterMallNoShippingGet();
    });
  }

  public formatterMallNoShippingGet(): void {
    let mallNoArr: any[] = [];
    let mallAndShipping: any[] = [];
    let formaterMAS: any[] = [];

    this.productInfo.forEach((item: any): any => {
      mallAndShipping.push({mallNo: item.mallNo, shippingNo: item.shippingNo});
    });
    mallAndShipping.forEach((mas: any): any => {
      if (mallNoArr.indexOf(mas.mallNo) < 0) {
        mallNoArr.push(mas.mallNo);
        formaterMAS.push(mas);
      } else {
        formaterMAS.forEach((fmas: any): any => {
          if (fmas.mallNo === mas.mallNo) {
            fmas.shippingNo = fmas.shippingNo.toString() + ',' + mas.shippingNo;
          }
        });
      }
    });
    formaterMAS.forEach((fmas: any): any => {
      this.getTheShippings(fmas.mallNo);
    });
  }

  public formatterProductInfo(arr: any, attribute: string): any {
    let newArr: any[] = [];
    arr.forEach((item: any): any => {
      item[attribute].forEach((opItem: any): any => {
        let obj: any = {};
        Object.keys(item).forEach((name: any): any => {
          if (name !== attribute) {
            obj[name] = item[name];
          }
        });
        Object.keys(opItem).forEach((opName: any): any => {
          obj[opName] = opItem[opName];
        });
        newArr.push(obj);
      });
    });
    newArr.sort((a: any, b: any): any => {
      return a.partnerNo - b.partnerNo;
    });
    return newArr;
  }

  public getTheShippings(mallNo: string): any {
    let shippingRequest: GetShippingsRequest = {
      params: {
        mallNo: mallNo,
        shippingNos: this.$route.query.shippingNo as any,
      }
    };
    this.$api.getShippings(shippingRequest).then(({data}): any => {
      data.forEach((val): any => {
        this.receiver = {
          orderNo: this.$route.query.orderNo as any,
          name: val.receiver.name,
          zipCd: val.receiver.zipCd,
          address: val.receiver.address,
          detailAddress: val.receiver.detailAddress,
          jibunAddress: val.receiver.jibunAddress,
          contact1: val.receiver.contact1,
          contact2: val.receiver.contact2,
          customsIdNumber: val.customsIdNumber,
          memo: val.memo,
          shippingNo: val.shippingNo as any
        }
      });
    });
  }

  private addressPopupCallback(address: OriginalAddress) {
    (window as any).addressCallback = undefined;
    this.receiver.zipCd = address.zipCode;
    this.receiver.address = address.roadAddress;
    this.receiver.detailAddress = address.roadAddressExtra;
    this.receiver.jibunAddress = address.jibunAddress;

  }

  private openAddressPopup() {
    (window as any).addressCallback = this.addressPopupCallback;
    ncpPopup('/address/search/popup?dataCallback=addressCallback', this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_POSTAL_CODE'), 550, 880);
  }

  public popupResize(): void {
    let contentWidth = $('#container').width() + 30;
    let contentHeight = $('#container').height() + 76;
    window.resizeTo(contentWidth, contentHeight);
  }

  public onClickSaveButton() {

    let request: any = {
      pathParams: {
        shippingNo: this.$route.query.shippingNo
      },
      data: {
        orderNo: this.$route.query.orderNo as any,
        name: this.receiver.name,
        zipCd: this.receiver.zipCd,
        address: this.receiver.address,
        detailAddress: this.receiver.detailAddress,
        jibunAddress: this.receiver.jibunAddress,
        contact1: this.receiver.contact1,
        contact2: this.receiver.contact2,
        customsIdNumber: this.receiver.customsIdNumber || '',
        memo: this.receiver.memo || '',
      }
    };

    if(this.formValidation()) {
      this.$api.putShippingsShippingNo(request).then((): any => {
        alert(this.$t('DELIVERY_MODIFY_POPUP_ALERT_SAVE'));
        window.opener.location.reload();
        this.close()
      })
    }
  }

  public formValidation() {

    const name = this.receiver.name;
    const zipCd = this.receiver.zipCd;
    const address = this.receiver.address;
    const detailAddress = this.receiver.detailAddress;
    const jibunAddress = this.receiver.jibunAddress;
    const contact1 = this.receiver.contact1;


    if (name === '') {
      alert(this.$t('DELIVERY_MODIFY_POPUP_VALIDATION_NAME'));
      $('#receiverName').focus();
      return false;
    }

    if (contact1 === '') {
      alert(this.$t('DELIVERY_MODIFY_POPUP_VALIDATION_CONTACT1'));
      $('#receiverContact1').focus();
      return false;
    }

    let hpRegExp = /^\d{3}-?\d{3,4}-?\d{4}$/;
    if (!hpRegExp.test(contact1)) {
      alert(this.$t('DELIVERY_MODIFY_POPUP_VALIDATION_CONTACT1_ERROR'));
      $('#receiverContact1').focus();
      return false;
    }

    if(zipCd === '' || address === '' || detailAddress === '' || jibunAddress === '') {
      alert(this.$t('DELIVERY_MODIFY_POPUP_VALIDATION_CONTACT1_ADDRESS'));
      $('#detailAddress').focus();
      return false;
    }

    return true;

  }


  public close(): void {
    window.close();
  }

  private mounted() {
    addClass(document.body, 'popup popup_small');
    setTimeout(() => {this.popupResize()},1000)
  }
}
